import React, { Children, lazy } from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
import { Crown, Sparkles } from 'lucide-react';
const bonos = [{
  title: 'Archivo Maestro 1: Mapa de Flujo 888',
  image: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/BONO_1_-_Mapa_de_Flujo_888.png?v=1778374268',
  desc: 'Mapa claro para alinear tu enfoque y dirección hacia nuevas oportunidades.',
  exclusive: false
}, {
  title: 'Archivo Maestro 2: La Llave Maestra de la Claridad Interior',
  image: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/BONO_2_-_LA_LLAVE_MAESTRA_DE_LA_ENERGIA_INTERNA.png?v=1778374268',
  desc: 'Claves prácticas para transformar tu relación con tus decisiones, hábitos y oportunidades.',
  exclusive: false
}, {
  title: 'Archivo Maestro 3: Protocolo de Manifestación Acelerada',
  image: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/BONO_3_-_Protocolo_de_Manifestacion_Acelerada.png?v=1778374268',
  desc: 'Protocolo simple para activar hábitos mentales más enfocados y conscientes.',
  exclusive: false
}, {
  title: 'Archivo Maestro 4: El Código de Expansión Suprema',
  image: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/BONO_4_-_EL_CODIGO_DE_EXPANSION_SUPREMA.png?v=1778375936',
  desc: 'Sistema estructurado para tomar decisiones con mayor claridad y confianza.',
  exclusive: false
}, {
  title: 'Archivo Maestro Exclusivo: Arquitectura Interna de Decisiones 888',
  image: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/BONO_Especial_-_Arquitectura_Interna_de_Decisiones_888.png?v=1778374268',
  desc: 'Ordena tu mente y toma decisiones con claridad, enfoque y seguridad.',
  exclusive: true
}, {
  title: 'Archivo Maestro Exclusivo: Protocolo de Integración y Expansión 888',
  image: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/BONO_Especial_-_Protocolo_de_Integracion_y_Expansion_888.png?v=1778374269',
  desc: 'Integra tus cambios internos y sostén una nueva forma de pensar y actuar.',
  exclusive: true
}];
export function QueIncluyeSection() {
  const [ref, isInView] = useInView({
    threshold: 0.1
  });
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="acceso-completo" className="py-16 sm:py-24 relative bg-[#050505] text-white overflow-hidden border-t border-white/5 scroll-mt-[56px] sm:scroll-mt-[70px]" data-id="element-570">
      {/* Premium Background Gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,#0B0B0B_0%,#050505_100%)] pointer-events-none" data-id="element-571" />

      {/* Subtle Gold Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[500px] bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.08),transparent_70%)] pointer-events-none" data-id="element-572" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-573">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12 sm:mb-16" data-id="element-574">
          {/* Section Label */}
          <span className="inline-block text-[#D4AF37] text-xs sm:text-sm font-bold tracking-[3px] uppercase mb-4" data-id="element-575">
            EXPERIENCIA COMPLETA
          </span>

          {/* Main Collection Mockup */}
          <div className="relative w-full max-w-3xl mx-auto mb-10 sm:mb-14 will-change-transform" data-id="element-576">
            <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(212,175,55,0.15),transparent_60%)] blur-2xl pointer-events-none" data-id="element-577" />
            <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/mookup.png?v=1778383528" alt="Colección Completa Código 888" width="800" height="600" sizes="(max-width: 768px) 100vw, 800px" className="w-full h-auto object-contain relative z-10 drop-shadow-[0_20px_40px_rgba(0,0,0,0.8)] rounded-xl transform-gpu backface-hidden" loading="lazy" style={{
            contentVisibility: 'visible',
            containIntrinsicSize: 'auto 800px 600px'
          }} data-id="element-578" />
          </div>

          {/* Headline */}
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-black leading-tight mb-6 drop-shadow-[0_0_15px_rgba(212,175,55,0.2)]" data-id="element-579">
            Todo lo que se activa cuando entras
          </h2>

          {/* Subheadline */}
          <p className="text-[#BFBFBF] text-base sm:text-lg max-w-2xl mx-auto font-medium leading-relaxed" data-id="element-580">
            No es solo una guía. Es un sistema completo diseñado para
            acompañarte en tu proceso interno y sostener tu transformación.
          </p>
        </motion.div>

        {/* Bonus Grid */}
        <motion.div variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-16" data-id="element-581">
          {bonos.map((bono, idx) => <motion.div key={idx} variants={itemVariants} className="group relative bg-[#0B0B0B] border border-white/5 rounded-2xl overflow-hidden transition-all duration-300 hover:border-[#E6C55A]/50 hover:shadow-[0_0_30px_rgba(212,175,55,0.15)] hover:-translate-y-1 flex flex-col" data-id="element-582">
              {/* Subtle inner glow */}
              <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-583" />

              {/* Exclusive Badge */}
              {bono.exclusive && <div className="absolute top-3 right-3 z-20 bg-[#D4AF37] text-black text-[9px] sm:text-[10px] font-black uppercase tracking-wider px-2 py-1 rounded-md shadow-[0_0_10px_rgba(212,175,55,0.5)] flex items-center gap-1" data-id="element-584">
                  <Sparkles className="w-3 h-3" data-id="element-585" />
                  Exclusivo
                </div>}

              {/* Image Container */}
              <div className="relative aspect-square w-full bg-[#050505] p-4 sm:p-6 flex items-center justify-center border-b border-white/5" data-id="element-586">
                <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(212,175,55,0.1),transparent_70%)] opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-587" />
                <img src={bono.image} alt={bono.title} width="400" height="400" sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 400px" className="w-full h-full object-contain relative z-10 drop-shadow-2xl group-hover:scale-105 transition-transform duration-500" loading="lazy" data-id="element-588" />
              </div>

              {/* Content */}
              <div className="p-4 sm:p-6 flex-1 flex flex-col" data-id="element-589">
                <div className="flex items-start justify-between gap-2 mb-2" data-id="element-590">
                  <h3 className={`font-bold text-sm sm:text-base leading-snug hidden sm:block ${bono.exclusive ? 'text-[#E6C55A]' : 'text-[#D4AF37]'}`} data-id="element-591">
                    {bono.title}
                  </h3>
                  <span className="shrink-0 bg-emerald-500/20 text-emerald-400 text-[10px] sm:text-xs font-black uppercase tracking-wider px-2 py-0.5 rounded-md border border-emerald-500/30" data-id="element-592">
                    GRATIS
                  </span>
                </div>
                <p className="text-[#8A8A8A] text-xs sm:text-sm leading-relaxed mt-auto" data-id="element-593">
                  {bono.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}